export enum DashboardGraph {
  Glucose = 'glucose',
  Combined = 'combined'
}
